import { useEffect } from 'react';
import { usePersonalizationTracker, BridgeApi } from '@skin-seoul/utils';

/**
 * Syncs actorId changes to the native app via bridge message.
 * Only active when running inside a React Native WebView.
 *
 * Both reInitialize() (login) and handleExternalLogout() (logout) go through
 * setActorIdAndNotify(), so this single listener covers all cases.
 *
 * Should be used alongside usePersonalizationAuthSync() in WebView contexts.
 */
export function useNativeBridgeActorSync() {
  const client = usePersonalizationTracker();

  useEffect(() => {
    if (!BridgeApi.isWebview()) {
      return;
    }

    const unsubscribe = client.onActorIdChange((actorId) => {
      const { sessionId, sessionTimestamp } = client.getSessionInfo();
      BridgeApi.actorIdResolved({ actorId, sessionId, sessionTimestamp });
    });

    return unsubscribe;
  }, [client]);
}
